import React from 'react'

// this file contains SVG soruces for icons, so that we can inline our SVGs and
// change their color dynamically.


import ProgressTriadLeft from "./ProgressTriadLeft";
import ProgressTriadCenter from "./ProgressTriadCenter";
import ProgressTriadRight from "./ProgressTriadRight";
import ProgressTriadLeftMobile from "./ProgressTriadLeftMobile";
import ProgressTriadCenterMobile from "./ProgressTriadCenterMobile";
import ProgressTriadRightMobile from "./ProgressTriadRightMobile";
import Checkmark from "./Checkmark";
import Search from "./Search";
import LinkArrow from "./LinkArrow";

const Icon = props => {
  switch (props.name) {
    case "progressTriadLeft":
      return <ProgressTriadLeft {...props} />;
    case "progressTriadCenter":
      return <ProgressTriadCenter {...props} />;
    case "progressTriadRight":
      return <ProgressTriadRight {...props} />;
    case "progressTriadLeftMobile":
      return <ProgressTriadLeftMobile {...props} />;
    case "progressTriadCenterMobile":
      return <ProgressTriadCenterMobile {...props} />;
    case "progressTriadRightMobile":
      return <ProgressTriadRightMobile {...props} />;
    case "checkmark":
      return <Checkmark {...props} />;
    case "linkarrow":
      return <LinkArrow {...props} />;
    case "search":
      return <Search {...props} />;
    default:
      return nil;
  }
};

export default Icon;